import { render } from "./wage-employee-competence-matrix.vue?vue&type=template&id=68a023e8&scoped=true"
import script from "./wage-employee-competence-matrix.vue?vue&type=script&lang=js"
export * from "./wage-employee-competence-matrix.vue?vue&type=script&lang=js"

import "./wage-employee-competence-matrix.vue?vue&type=style&index=0&id=68a023e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a023e8"],['__file',"src/components/applications/wagesetting/wage-employee-competence-matrix.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68a023e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68a023e8', __exports__)) {
    api.reload('68a023e8', __exports__)
  }
  
  module.hot.accept("./wage-employee-competence-matrix.vue?vue&type=template&id=68a023e8&scoped=true", () => {
    api.rerender('68a023e8', render)
  })

}


export default __exports__